import { Box, Center, MantineSize, Progress, Stack, TextInput } from '@mantine/core';
import { IconTrashX, IconX } from '@tabler/icons-react';
import P2Regular from 'components/typography/P2Regular';
import FileThumbnail from 'components/files/FileThumbnail';
import ActionIcon from 'components/ActionIcon';

/**
 * Indicator for a file upload.
 */
export default function UploadProgressIndicator({
  fileId,
  fileName,
  progress,
  finalized,
  onDelete,
  onFileNameChange,
  inputSize = 'sm',
}: {
  fileId?: string;
  fileName: string;
  progress: number;
  finalized: boolean;
  onDelete: () => void;
  onFileNameChange: (fileName: string) => void;
  inputSize?: MantineSize;
}) {
  return (
    <Stack spacing={0} className="overflow-hidden" py={4} pr={16}>
      <div className="grid grid-cols-[auto_1fr_auto] items-center justify-start gap-2">
        <Center w={80} h={80}>
          {fileId && finalized ? <FileThumbnail fileId={fileId} showSlider={false} /> : <Box />}
        </Center>
        {finalized ? (
          <TextInput size={inputSize} value={fileName} onChange={(e) => onFileNameChange(e.currentTarget.value)} />
        ) : (
          <P2Regular>{fileName}</P2Regular>
        )}
        <div className="cursor-pointer" onClick={onDelete}>
          <ActionIcon size="sm" variant="danger-secondary" p={6}>
            {finalized ? <IconTrashX /> : <IconX />}
          </ActionIcon>
        </div>
      </div>
      {!finalized && <Progress mt={-20} ml={88} mr={12} h={4} value={progress * 100} />}
    </Stack>
  );
}
